import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Logo } from "@/components/Logo";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { loginWithTotalKlick } from "@/lib/totalklick";

export default function ConsultantLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success("Benvenuto!");
      if (data.user.role === "superadmin") navigate("/admin");
      else navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login fallito");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0F172A] via-[#1E293B] to-[#0F172A] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/"><Logo className="h-16 mx-auto" variant="dark" /></Link>
        </div>
        <div className="bg-white rounded-3xl p-8 shadow-2xl">
          <h1 className="text-2xl font-black text-[#1E293B] mb-1">Accedi</h1>
          <p className="text-sm text-slate-500 mb-6">Il sistema riconoscerà automaticamente il tuo profilo</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label-gs">Email</label>
              <input data-testid="login-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="input-gs" autoComplete="email" />
            </div>
            <div>
              <label className="label-gs">Password</label>
              <input data-testid="login-password-input" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="input-gs" autoComplete="current-password" />
            </div>
            <button data-testid="login-submit-button" type="submit" disabled={loading}
              className="btn-gs-primary w-full disabled:opacity-60">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Accedi"}
            </button>
          </form>

          {/* SSO TotalKlick */}
          <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
            <div className="flex-1 h-px bg-slate-200" />
            <span>oppure</span>
            <div className="flex-1 h-px bg-slate-200" />
          </div>
          <button
            type="button"
            onClick={() => loginWithTotalKlick("/auth/sso/callback")}
            data-testid="login-sso-totalklick-btn"
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#1E293B] hover:bg-[#0F172A] text-white font-bold text-sm"
          >
            <ShieldCheck className="w-4 h-4" />
            Accedi con TotalKlick
          </button>
          <p className="mt-2 text-[11px] text-slate-400 text-center">
            Account TotalKlick? Accedi senza inserire email/password.
          </p>

          <div className="mt-6 text-center text-sm text-slate-500">
            Non hai un account?{" "}
            <Link to="/register-consultant" className="text-[#2456C6] font-bold hover:underline">
              Registrati come consulente
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
